import { useEffect } from "react";
import { MuiTelInput } from "mui-tel-input";

export const PhoneInput = ({
  value,
  setValue,
  setPhoneData,
  error,
  setError,
  disabled,
  readOnly,
}: any) => {
  // `value` is not always a string. A phone number that round-trips through the
  // API as a number has no `startsWith`, and optional chaining does not help:
  // `value?.startsWith` only guards null and undefined, so for a number the
  // property access succeeds and the *call* is what throws. That throw happens
  // during render, so the customer gets a blank step rather than a broken
  // field. Coerce once here and read from `raw` below.
  // (Sentry FS-CUSTOMER-PORTAL-FE-5C)
  const raw = value == null ? "" : String(value);
  const nationalValue = raw.startsWith("+") ? raw.slice(2) : raw;

  useEffect(() => {
    // Coerced inline rather than reading `raw`, to keep this effect's
    // dependency list exactly as it was.
    if (String(value ?? "").startsWith("+")) {
      setValue(nationalValue);
    }
  }, [value]);

  const onChange = (newValue: any, info: any) => {
    const { nationalNumber, countryCode, numberValue } = info;

    if (
      !numberValue ||
      nationalNumber?.length > 10 ||
      nationalNumber === nationalValue ||
      (numberValue?.length > 13 && countryCode !== "US")
    ) {
      return;
    }

    if (setPhoneData) {
      setPhoneData(info);
    }
    setError(false);
    setValue(nationalNumber);
  };

  return (
    <MuiTelInput
      label="Phone"
      defaultCountry="US"
      onlyCountries={["US", "PH"]}
      disableDropdown={
        process.env.REACT_APP_HOST_ENV !== "development" || readOnly
      }
      value={`+1${nationalValue}`}
      onChange={onChange}
      error={error}
      helperText={error ? "Invalid phone number" : ""}
      disabled={disabled}
      forceCallingCode
      className={readOnly ? "MuiInputBase-readOnly" : ""}
      inputProps={{
        readOnly: readOnly,
        inputMode: "numeric",
        pattern: "[0-9]*",
      }}
    />
  );
};
